import Vue from "vue";
import wrap from "@vue/web-component-wrapper";

const SpecifyUsageParent = () =>
  import("@/components/biologicals/SpaceMaterialsUsage/SpecifyUsageParent.vue");
const BioSpaceSpecifyUsageParentWebComponent = wrap(Vue, SpecifyUsageParent);
window.customElements.define(
  "bio-space-materials-usage-wc",
  BioSpaceSpecifyUsageParentWebComponent,
);
